import { SubscriptionPaymentMethod } from './subscriptionPaymentMethod.js';
export const CHECKOUT_WORDING_KEYS = {
    declaration: 'CHECKOUT.NOTES.ACCEPT_TERMS',
    minimumTerm: 'CHECKOUT.NOTES.MINIMUM_TERM',
    minimumTermWithoutProlongation: 'CHECKOUT.NOTES.MINIMUM_TERM_NO_RENEWAL',
    noMonthlyCancellation: 'CHECKOUT.NOTES.NO_MONTHLY_CANCELLATION',
    continueToPayment: 'CHECKOUT.CTA.CONTINUE_TO_PAYMENT',
    submitOrder: 'CHECKOUT.CTA.SUBMIT_ORDER',
    submitOrderStartFree: 'CHECKOUT.CTA.SUBMIT_ORDER_START_FREE',
};
export const checkoutNoteEntries = ({ autoProlongation, commitmentLengthInMonths, }) => [
    {
        key: autoProlongation
            ? CHECKOUT_WORDING_KEYS.minimumTerm
            : CHECKOUT_WORDING_KEYS.minimumTermWithoutProlongation,
        params: { months: commitmentLengthInMonths },
    },
    { key: CHECKOUT_WORDING_KEYS.noMonthlyCancellation },
];
export const checkoutConfirmLabelKey = ({ paymentMethod, initialFreeDays, }) => {
    if (paymentMethod !== SubscriptionPaymentMethod.Invoice) {
        return CHECKOUT_WORDING_KEYS.continueToPayment;
    }
    return initialFreeDays > 0 ? CHECKOUT_WORDING_KEYS.submitOrderStartFree : CHECKOUT_WORDING_KEYS.submitOrder;
};
